export function head<T>(array: T[]): T | undefined {
  return array != null && array.length ? array[0] : undefined
}

export function random<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]
}
